<footer class="site-footer">
  <div class="footer-top">
    <div class="footer-brand">
      <img [src]="branding.logoUrl()" alt="McDonald's" class="footer-logo" />
      <div class="footer-brand-text">
        <span class="footer-name">McTemplate</span>
        <span class="footer-owner">Owned & Operated by Gav's Nexus</span>
      </div>
    </div>

    <div class="footer-links">
      <a href="mailto:callmehgav@gmail.com?cc=ganderson96@live.com&subject=Website%20Inquiry">
        Contact Me
      </a>
      <a
        routerLink="/terms-privacy">
        Terms & Privacy Policy
      </a>
    </div>
  </div>

  <div class="footer-divider"></div>

  <div class="footer-bottom">
    <p>© {{ currentYear }} Gav's Nexus — All rights reserved.</p>
    <img src="assets/logos/guaranteeT.png" alt="Guarantee" class="guarantee" loading="lazy" />
  </div>
</footer>
